/* eslint-disable react/no-danger */
import React, { useState, useRef } from "react";

import "./Accordion.css";
import Chevron from "./Chevron";

const Accordion = (props) => {
  const [setActive, setActiveState] = useState("");
  const [setHeight, setHeightState] = useState("0px");
  const [setDisplay, setDisplayState] = useState("displayBorder");
  const [setRotate, setRotateState] = useState("accordion__icon");
  const [setColor, setColorState] = useState("#526BAE");
  const [hideBorder, setHideBorder] = useState("accordion");
  const content = useRef(null);

  function toggleAccordion() {
    setActiveState(setActive === "" ? "active" : "");
    setHeightState(
      setActive === "active" ? "0px" : `${content.current.scrollHeight}px`
    );
    setRotateState(
      setActive === "active" ? "accordion__icon" : "accordion__icon rotate"
    );
    setColorState(setActive === "active" ? "#526BAE" : "#526BAE");

    setDisplayState(
      setActive === "active" ? "displayBorder" : "accordion__content"
    );
    setHideBorder(setActive === "active" ? "accordion" : "accordion-active");
  }

  return (
    <div className="accordion__section z-0">
      <button
        type="button"
        className={`${hideBorder} ${setActive}`}
        onClick={toggleAccordion}
      >
        <div className={`accordion__title ${setActive}`}>{props.title}</div>
        <Chevron
          className={`${setRotate}`}
          width={16}
          height={16}
          fill={`${setColor}`}
        />
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className={`${setDisplay}`}
      >
        <div
          className="accordion__text "
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
      </div>
    </div>
  );
};

export default Accordion;
